import { useRouter } from "next/router";

import HeaderNavigations from "./Headers/HeaderNavigations";
import DarkSwitch from "./dark-switch";
import LanguageFloatingWidget from "@/my_components/Common/LanguageFloatingWidget";
import { useAppContext } from "@/context/Context";
import { useProfile } from "@/context/ProfileContext";



const HeaderContainer = ({ headerSticky, headerType="", topBarToggle="on", topBarType="type 2", blendWithHero=false }) => {

  const { isLightTheme, toggleTheme } = useAppContext();
  // Signed-in users get the language switcher in the navbar (HeaderRight.js) instead -- this
  // floating widget is reserved for logged-out visitors, so the two are never both on screen.
  const { profile, loading: profileLoading, loggedIn: contextLoggedIn } = useProfile();
  const loggedIn = !profileLoading && contextLoggedIn && !!profile;

  const router = useRouter();

  return (
    <>

      <DarkSwitch isLight={isLightTheme} switchTheme={toggleTheme} />
      {!profileLoading && !loggedIn && <LanguageFloatingWidget />}


      {/* <header className="rbt-header rbt-header-10 rbt-transparent-header"> */}
      <header className={`rbt-header rbt-header-10${headerType}`}>

        {/* The promotional topbar ("Ready to stay ahead? Learn with us.") has been removed
            site-wide per explicit request -- it's no longer rendered regardless of the
            topBarToggle/topBarType props any page passes in. */}

        <HeaderNavigations
          headerSticky={headerSticky}
          sticky="header-sticky"
          container="container-fluid"
          gapSpaceBetween="header-space-betwween"
          navigationEnd="rbt-navigation-start"
          blendWithHero={blendWithHero}
        />

      </header>
    </>

  );

};

export default HeaderContainer;
